import { render, staticRenderFns } from "./useCrisp.vue?vue&type=template&id=73183c80&scoped=true"
import script from "./useCrisp.vue?vue&type=script&lang=js"
export * from "./useCrisp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73183c80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73183c80')) {
      api.createRecord('73183c80', component.options)
    } else {
      api.reload('73183c80', component.options)
    }
    module.hot.accept("./useCrisp.vue?vue&type=template&id=73183c80&scoped=true", function () {
      api.rerender('73183c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/useCrisp.vue"
export default component.exports